/** @format */

module.exports = [
  // {
  //   name: "otp-internal",
  //   title: "Flow with Internal OTP support",
  // },
  {
    name: "spain",
    title: "Variant for Spanish flow",
  },
  {
    name: "denmark",
    title: "Variant for Denmark flow",
  },
  // {
  //   name: "nationality-selector",
  //   title: "Variant of core with nationality selector",
  // },
  // {
  //   name: "otp-internal-country",
  //   title: "Flow with Internal OTP support with country selector",
  // },
];



// WEBPACK FOOTER //
// ./src/partners/config/variants.js